// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1wXh4","title":"FrontImage_title__3kno8"};